<ng-container *transloco="let t">
  <!-- Hamburger button for mobile -->
  <button *ngIf="showMobileBurger" class="mobile-hamburger" (click)="toggleMobileMenu()" [class.open]="isMobileMenuOpen">
    <span class="hamburger-line"></span>
    <span class="hamburger-line"></span>
    <span class="hamburger-line"></span>
  </button>

  <!-- Backdrop overlay -->
  <div class="mobile-backdrop" *ngIf="isMobileMenuOpen" (click)="closeMobileMenu()"></div>

<div class="sidebar-container" [ngClass]="{'disabled': disabled}" *ngIf="sidebarConfig" [class.mobile-open]="isMobileMenuOpen">
  <div class="first-level-container" [style.background-color]="sidebarConfig.backgroundColor">
    <a
      [ngClass]="{
        'link-disabled': !homeLink
      }"
      class="logo pointer"
      [routerLink]="homeLink"
    >
      <img [src]="sidebarConfig.logoPath" alt="logo" />
    </a>

    <ul>
      <ng-container *ngFor="let item of firstLevelMenuItems">
        <li [class.selected]="item.selected" [title]="item.label">
          <a *ngIf="item.isHref" [href]="item.url" [target]="item.targetId ?? '_blank'">
            <img class="first-level-icon"
                 [src]="'assets/img/sidebar/' + ((item.selected && item.selectedIcon) ? item.selectedIcon : item.icon)"
                 [alt]="item.label" />
          </a>
          <a *ngIf="!item.isHref" [routerLink]="item.url">
            <img class="first-level-icon"
                 [src]="'assets/img/sidebar/' + ((item.selected && item.selectedIcon) ? item.selectedIcon : item.icon)"
                 [alt]="item.label" />
          </a>
        </li>
        <div class="divider" *ngIf="item.divider"></div>
      </ng-container>
    </ul>

  </div>

  <!-- second-level menu; collapsed, it narrows to a rail of icons with tooltips and the toggle keeps its place -->
  <ng-container *ngIf="{ collapsed: (sidebarService.secondLevelCollapsed$ | async) === true && !isMobileMenuOpen } as menu">
  <div
    class="second-level-container"
    *ngIf="hasSecondLevel && (sidebarService.secondLevelMenuVisible$ | async)"
    [class.collapsed]="menu.collapsed"
  >
    <div class="second-level-header">
      <h1 *ngIf="!menu.collapsed" class="second-level-title">{{ currentSectionTitle }}</h1>
      <button
        *ngIf="!isMobileMenuOpen"
        type="button"
        class="second-level-toggle"
        (click)="sidebarService.setSecondLevelCollapsed(!menu.collapsed)"
        [title]="t(menu.collapsed ? 'shared/showMenu' : 'shared/hideMenu')"
        [attr.aria-label]="t(menu.collapsed ? 'shared/showMenu' : 'shared/hideMenu')"
        [attr.aria-expanded]="!menu.collapsed"
      >
        <i class="material-symbols-rounded">{{ menu.collapsed ? 'left_panel_open' : 'left_panel_close' }}</i>
      </button>
    </div>

      <ul class="side-menu">
        <li *ngFor="let item of currentMenuItems" class="slide">
          <div *ngIf="item.subtitle" class="side-menu__subtitle">{{ item.subtitle }}</div>

          <a
            *ngIf="!item.isHref"
            class="side-menu__item"
            [class.locked]="item.locked"
            [routerLink]="item.url"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: item.exactMatch !== false }"
            #routerLinkRef="routerLinkActive"
            [ngbTooltip]="menu.collapsed ? item.menuText : ''"
            placement="end"
            container="body"
            [attr.aria-label]="menu.collapsed ? item.menuText : null"
            (click)="onSecondLevelMenuItemClick()"
          >
            <span class="side-menu__icon" [class.locked]="item.locked">
            <img
              *ngIf="item.icon.endsWith(PNG_EXTENSION)"
              class="first-level-icon"
              [class.inactive]="!routerLinkRef.isActive && !item.colorIcon"
              [src]="'assets/img/menu-items/' + item.icon"
              [alt]="item.menuText"
            />
            <i *ngIf="!item.icon.endsWith(PNG_EXTENSION)" class="material-symbols-rounded">{{ item.icon }}</i>
            <span *ngIf="item.locked" class="lock-badge">
              <i class="material-symbols-rounded filled">lock</i>
            </span>
            </span>
            <span class="side-menu__label">{{ item.menuText }}</span>

            <span *ngIf="item.enrollmentState$">
            <i *ngIf="(item.enrollmentState$ | async) === null" [class]="icons.star"></i>
          </span>
          </a>

        <a *ngIf="item.isHref" class="side-menu__item" [class.locked]="item.locked" [href]="item.url" [target]="item.targetId ?? '_blank'"
           [ngbTooltip]="menu.collapsed ? item.menuText : ''" placement="end" container="body"
           [attr.aria-label]="menu.collapsed ? item.menuText : null"
           (click)="onSecondLevelMenuItemClick()">
          <span class="side-menu__icon" [class.locked]="item.locked">
            <img
              *ngIf="item.icon.endsWith(PNG_EXTENSION)"
              class="first-level-icon"
              [src]="'assets/img/menu-items/' + item.icon"
              [alt]="item.menuText"
            />
            <i *ngIf="!item.icon.endsWith(PNG_EXTENSION)" class="material-symbols-rounded">{{ item.icon }}</i>
            <span *ngIf="item.locked" class="lock-badge">
              <i class="material-symbols-rounded filled">lock</i>
            </span>
          </span>
          <span class="side-menu__label">{{ item.menuText }}</span>

            <span *ngIf="item.enrollmentState$">
            <i *ngIf="(item.enrollmentState$ | async) === null" [class]="icons.star"></i>
          </span>
          </a>

          <hr *ngIf="item.divider" />
        </li>
      </ul>

      <div class="demo-switch-wrapper" *ngIf="showDemoSwitch && !menu.collapsed">
        {{ t('shared/tryApp') }}
        <button (click)="onSwitchToDemoClick()" class="btn btn-primary">
          {{ t('shared/demoKindergarten') }}
        </button>
      </div>
    </div>
  </ng-container>
  </div>
</ng-container>
